import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { t } from '@insight/toolkit-utils'
import Button from '../Button/Button'

export default function PDPTechSpecs({ technicalSpecs }) {
  const [expanded, setExpanded] = useState(false)
  if (!technicalSpecs || !technicalSpecs.length) return null
  const renderTechSpecs = () => {
    return technicalSpecs.map(({ label, details }) => {
      return (
        <div className="c-pdp__tech-specs" key={label}>
          <h5 className="u-text-bold u-margin-bot-tiny">{label}</h5>
          <table className="c-pdp__tech-specs--table">
            <tbody>
              {details.map(({ label, value }) => (
                <tr
                  key={label}
                  className="o-grid u-padding-tiny c-pdp__tech-specs--table-row"
                >
                  <div className="o-grid__item u-1/2">
                    <td className="c-pdp__tech-specs--table-data">{label}</td>
                  </div>
                  <div className="o-grid__item u-1/2">
                    <td className="c-pdp__tech-specs--table-data u-text-bold">
                      {value}
                    </td>
                  </div>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )
    })
  }
  return (
    <Fragment>
      <div
        className={cn('o-grid__item u-1/1 u-margin-bot-small', {
          'c-pdp__tech-specs--info': !expanded,
        })}
      >
        {renderTechSpecs()}
      </div>
      <div className="o-grid o-grid--justify-center">
        <div className="o-grid__item o-grid__item--shrink">
          <Button
            icon={expanded ? 'remove' : 'add'}
            onClick={() => setExpanded(!expanded)}
            color="link"
          >
            {t(`View ${expanded ? 'less' : 'more'} specifications`)}
          </Button>
        </div>
      </div>
    </Fragment>
  )
}

PDPTechSpecs.propTypes = {
  technicalSpecs: PropTypes.arrayOf(PropTypes.object).isRequired,
}
